import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { Grid, LinearProgress } from '@material-ui/core';
import { CategoryDetails } from './components'
import uuid from 'uuid'

//graphql stuff
import gql from 'graphql-tag'
import { getCategory } from 'graphql/queries'
import { useQuery } from 'react-apollo-hooks'

const getCategoryQuery = gql`${getCategory}`

const styles = theme => ({
  root: {
    padding: theme.spacing(4)
  },
  button: {
    paddingBottom: '5px'
  }
});

const CategoryDetail = (props) => {
  const { classes } = props
  const { data, loading } = useQuery(getCategoryQuery, { variables: { id: props.match.params.id }})
  const [ category, setCategory ] = useState({id: uuid(), name:'',description:''})

  useEffect(() => {
    if(data.getCategory && data.getCategory !== 'undefined') setCategory(data.getCategory)
  },[data])
  
  return (
    <div className={classes.root}>
        {( (loading || category.name === '') && props.match.params.id !== 'new') ? (
          <div className={classes.progressWrapper}>
            <LinearProgress />
          </div>
        ):(
        <Grid container spacing={4}>
          <Grid item lg={12} md={12} xl={12} xs={12}>
            <CategoryDetails category={category} {...props}/>
          </Grid>
        </Grid>
        )}
    </div>
  );
}

CategoryDetail.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CategoryDetail);